import { render, staticRenderFns } from "./TheCodeButton.vue?vue&type=template&id=397f89cb&"
import script from "./TheCodeButton.vue?vue&type=script&lang=js&"
export * from "./TheCodeButton.vue?vue&type=script&lang=js&"
import style0 from "./TheCodeButton.vue?vue&type=style&index=0&id=397f89cb&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports